<template>
  <div id="index" class="index">
    <div class="header">
      <div class="header_left">
        <img src="../assets/logo.png" class="logo_image">
        <img src="../assets/header_left_hr.png" class="header_left_hr">
        <img src="../assets/header_left_address.png" class="header_left_address">
        <p class="header_address">{{weatherName}}</p>
      </div>
      <h1 class="header_center">江苏保力智慧公厕引导系统</h1>
      <div class="header_right">
        <i class="iconfont weather_icon" :class="weather[wid]" v-if="wid"></i>
        <p class="week">{{weeks}}</p>
        <p class="date_time">{{dateTime}}</p>
      </div>
    </div>
    <div class="tbody">
      <div class="tbody_left">
        <div class="left_title"><span>用户满意度统计</span></div>
        <div class="left_top_tbody">
          <p class="left_top_tbody_item">
            <span>满意</span>
            <img src="../assets/satisfied_image.png" class="face">
            <span>{{Satisfaction.satisfied}}%</span>
          </p>
          <p class="left_top_tbody_item">
            <span>一般</span>
            <img src="../assets/commonly.png" class="face">
            <span>{{Satisfaction.commonly}}%</span>
          </p>
          <p class="left_top_tbody_item">
            <span>不满意</span>
            <img src="../assets/no_satisfied.png" class="face">
            <span>{{Satisfaction.difference}}%</span>
          </p>
        </div>
        <div class="left_title"><span>人流量统计</span></div>
        <div class="left_center_tbody">
          <div class="left_center_tbody_left">
            <p class="left_center_tbody_left_number">{{peopleFlow.peopleFlowSum}}</p>
          </div>
          <div class="left_center_tbody_right">
            <div class="left_center_tbody_right_item">
              <img src="../assets/female_number.png" class="number_images">
              <p class="number_text">{{peopleFlow.peopleFlowFemale}}</p>
            </div>
            <div class="left_center_tbody_right_item">
              <img src="../assets/male_number.png" class="number_images">
              <p class="number_text">{{peopleFlow.peopleFlowMale}}</p>
            </div>
            <div class="left_center_tbody_right_item">
              <img src="../assets/in_number.png" class="number_images in_number_images">
              <p class="number_text in_number_text">{{peopleFlow.peopleFlowThird}}</p>
            </div>
          </div>
        </div>
        <div class="left_title left_title764"><span>环境监测统计</span></div>
        <div class="left_bottom_tbody">
          <div class="left_bottom_tbody_title">
            <p class="left_bottom_tbody_item_width left_bottom_tbody_item_title_height"></p>
            <p class="left_bottom_tbody_item_width left_bottom_tbody_item_title_height">男卫生间</p>
            <p class="left_bottom_tbody_item_width left_bottom_tbody_item_title_height">女卫生间</p>
            <p class="left_bottom_tbody_item_width left_bottom_tbody_item_title_height left_bottom_tbody_item_align">第三卫生间</p>
          </div>
          <div class="left_bottom_tbody_list">
            <div class="left_bottom_tbody_item_width">
              <p class="left_bottom_tbody_item_p">硫化氢(mg/m³):</p>
              <p class="left_bottom_tbody_item_p">PM2.5(mg/m³):</p>
              <p class="left_bottom_tbody_item_p">氨气（mg/m³）:</p>
            </div>
            <div class="left_bottom_tbody_item_width">
              <p class="left_bottom_tbody_item_p left_bottom_tbody_item_p_color">{{testing.male_H2S}}</p>
              <p class="left_bottom_tbody_item_p left_bottom_tbody_item_p_color">{{testing.male_pm2_5}}</p>
              <p class="left_bottom_tbody_item_p left_bottom_tbody_item_p_color">{{testing.male_nh3}}</p>
            </div>
            <img src="../assets/left_bottom_tbody_hr.png" class="left_bottom_tbody_hr">
            <div class="left_bottom_tbody_item_width">
              <p class="left_bottom_tbody_item_p left_bottom_tbody_item_p_color">{{testing.female_H2S}}</p>
              <p class="left_bottom_tbody_item_p left_bottom_tbody_item_p_color">{{testing.female_pm2_5}}</p>
              <p class="left_bottom_tbody_item_p left_bottom_tbody_item_p_color">{{testing.female_nh3}}</p>
            </div>
            <img src="../assets/left_bottom_tbody_hr.png" class="left_bottom_tbody_hr">
            <div class="left_bottom_tbody_item_width">
              <p class="left_bottom_tbody_item_p left_bottom_tbody_item_p_color">{{testing.third_H2S}}</p>
              <p class="left_bottom_tbody_item_p left_bottom_tbody_item_p_color">{{testing.third_pm2_5}}</p>
              <p class="left_bottom_tbody_item_p left_bottom_tbody_item_p_color">{{testing.third_nh3}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="tbody_right">
        <div class="tbody_right_top">
          <div class="tbody_right_top_item tbody_right_top_item_left">
            <p class="tbody_right_top_item_top tbody_right_top_item_top_color1">女厕</p>
            <div class="tbody_right_top_item_bottom">
              <p class="tbody_right_top_item_bottom_left">{{female.surplus}}</p>
              <p class="tbody_right_top_item_bottom_right">未使用</p>
            </div>
          </div>
          <div class="tbody_right_top_item tbody_right_top_item_right">
            <p class="tbody_right_top_item_top tbody_right_top_item_top_color2">男厕</p>
            <div class="tbody_right_top_item_bottom">
              <p class="tbody_right_top_item_bottom_left">{{male.surplus}}</p>
              <p class="tbody_right_top_item_bottom_right">未使用</p>
            </div>
          </div>
        </div>
        <div class="tbody_right_bottom">
          <div class="tbody_right_bottom_list">
            <!--女-->
            <p class="tbody_right_bottom_list_item tbody_right_bottom_list_item_1" v-if="female.list[3].state">
              <img src="../assets/female_icon.png" class="images_icon">
            </p>
            <p class="tbody_right_bottom_list_item tbody_right_bottom_list_item_2" v-if="female.list[2].state">
              <img src="../assets/female_icon.png" class="images_icon">
            </p>
            <p class="tbody_right_bottom_list_item tbody_right_bottom_list_item_3" v-if="female.list[1].state">
              <img src="../assets/female_icon.png" class="images_icon">
            </p>
            <p class="tbody_right_bottom_list_item tbody_right_bottom_list_item_4" v-if="female.list[0].state">
              <img src="../assets/female_icon.png" class="images_icon">
            </p>
            <!--三-->
            <p class="tbody_right_bottom_list_item tbody_right_bottom_list_item_5">

            </p>
            <p class="tbody_right_bottom_list_item tbody_right_bottom_list_item_6">

            </p>
            <p class="tbody_right_bottom_list_item tbody_right_bottom_list_item_7">

            </p>
            <!--男-->
            <p class="tbody_right_bottom_list_item tbody_right_bottom_list_item_8" v-if="male.list[3].state">
              <img src="../assets/male_icon.png" class="images_icon">
            </p>
            <p class="tbody_right_bottom_list_item tbody_right_bottom_list_item_9" v-if="male.list[2].state">
              <img src="../assets/male_icon.png" class="images_icon">
            </p>
            <p class="tbody_right_bottom_list_item tbody_right_bottom_list_item_10" v-if="male.list[1].state">
              <img src="../assets/male_icon.png" class="images_icon">
            </p>
            <p class="tbody_right_bottom_list_item tbody_right_bottom_list_item_11" v-if="male.list[0].state">
              <img src="../assets/male_icon.png" class="images_icon">
            </p>
          </div>
          <p class="tbody_right_bottom_bg"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import "../../static/css/balicss.css"
  import "../../static/fonts/iconfont.css"

  export default {
    name: "index",
    data() {
      return {
        weather: {
          "00": "icon-00",//晴
          "01": "icon-01",//多云
          "02": "icon-02",//阴
          "03": "icon-03",//阵雨
          "04": "icon-04",//雷阵雨
          "05": "icon-05",//雷阵雨伴有冰雹
          "06": "icon-06",//雨夹雪
          "07": "icon-07",//小雨
          "08": "icon-08",//中雨
          "09": "icon-09",//大雨
          "10": "icon-10",//暴雨
          "11": "icon-11",//大暴雨
          "12": "icon-12",//特大暴雨
          "13": "icon-13",//阵雪
          "14": "icon-14",//小雪
          "15": "icon-15",//中雪
          "16": "icon-16",//大雪
          "17": "icon-17",//暴雪
          "18": "icon-18",//雾
          "19": "icon-19",//冻雨
          "20": "icon-20",//沙尘暴
          "21": "icon-21",//小到中雨
          "22": "icon-22",//中到大雨
          "23": "icon-23",//大到暴雨
          "24": "icon-24",//暴雨到大暴雨
          "25": "icon-25",//"大暴雨到特大暴雨
          "26": "icon-26",//小到中雪
          "27": "icon-27",//中到大雪
          "28": "icon-28",//大到暴雪
          "29": "icon-19",//浮沉
          "30": "icon-30",//扬沙
          "31": "icon-31",//强沙尘暴
          "53": "icon-53"//霾
        },//天气文文字图标
        addressKey: 'tqusWRUhEjfhnB5R8WhTTwBrhmBfFtVk',//百度获取地位key
        weatherName: '北京',//默认位置
        weeks: "",//星期
        dateTime: '',//日期时间
        wid: '00',//天气id
        setDateTime: 0,//定时器
        male: {
          temperature: '00.00',//温度
          humidity: '00.00',//湿度
          surplus: 4,//剩余数
          list: [{"id": 1, "state": 0},
            {"id": 2, "state": 0},
            {"id": 3, "state": 0},
            {"id": 4, "state": 0}]//厕所状态（state:0无人，1有人）
        },//男厕数据
        female: {
          temperature: '00.00',
          humidity: '00.00',
          surplus: 4,
          list: [{"id": 1, "state": 0},
            {"id": 2, "state": 0},
            {"id": 3, "state": 0},
            {"id": 4, "state": 0}]//state:0无人，1有人
        },//女厕数据
        third: {
          temperature: '00.00',
          humidity: '00.00',
          surplus: 3,
          list: [{"id": 1, "state": 0},
            {"id": 2, "state": 0},
            {"id": 3, "state": 0}]//state:0无人，1有人
        },//第三厕数据
        Satisfaction: {
          satisfied: 99,
          commonly: 1,
          difference: 0
        },//满意度
        peopleFlow: {
          peopleFlowSum: 0,
          peopleFlowMale: 0,
          peopleFlowFemale: 0,
          peopleFlowThird: 0
        },//人流量
        testing:{
          "male_H2S":'0.00',
          "male_pm2_5":"0.00",
          "male_nh3":"0.00",
          "female_H2S":"0.00",
          "female_pm2_5":"0.00",
          "female_nh3":"0.00",
          "third_H2S":"0.00",
          "third_pm2_5":"0.00",
          "third_nh3":"0.00"
        },
        timeout: "",
        toUpdData:0,//时间
      }
    },
    beforeCreate() {
      let that=this;
      window['external']['getDevInfo'] = () => {
        let obj = {
          "id": "JRZN600001",
          "netStatus": "Online",
          "WaterConsumption": 123.34,
          "PowerConsumption": 3213.13,
          "time": that.dateTime,
          "mensInfo": {//男厕信息
            "humidity": (that.randomNum(100,1000)/10).toFixed(2),
            "temperature": (that.randomNum(200,400)/10).toFixed(2),
            "co2": 10,
            "nh3": (that.randomNum(1000,9999)/100).toFixed(2),
            "H2S": (that.randomNum(1000,9999)/100).toFixed(2),
            "pm2_5": (that.randomNum(1000,9999)/100).toFixed(2),
            "pm10": 32,
            "dayTraffic": that.randomNum(100,1000),
            "totalTraffic": that.randomNum(1000,99999),
            "nums": 4,
            "list": [
              {
                "index": 1,
                "state": that.randomNum(1,10)%2
              },
              {
                "index": 2,
                "state": that.randomNum(1,10)%2
              },
              {
                "index": 3,
                "state": that.randomNum(1,10)%2
              },
              {
                "index": 4,
                "state": that.randomNum(1,10)%2
              }
            ]
          },
          "womensInfo": {//女厕信息
            "humidity": (that.randomNum(100,1000)/10).toFixed(2),
            "temperature": (that.randomNum(200,400)/10).toFixed(2),
            "co2": 10,
            "nh3": (that.randomNum(1000,9999)/100).toFixed(2),
            "H2S": (that.randomNum(1000,9999)/100).toFixed(2),
            "pm2_5": (that.randomNum(1000,9999)/100).toFixed(2),
            "pm10": 32,
            "dayTraffic": that.randomNum(100,1000),
            "totalTraffic": that.randomNum(1000,99999),
            "nums": 4,
            "list": [
              {
                "index": 1,
                "state": that.randomNum(1,10)%2
              },
              {
                "index": 2,
                "state": that.randomNum(1,10)%2
              },
              {
                "index": 3,
                "state": that.randomNum(1,10)%2
              },
              {
                "index": 4,
                "state": that.randomNum(1,10)%2
              }
            ]
          },
          "thirdsInfo": {//第三信息
            "humidity": (that.randomNum(100,1000)/10).toFixed(2),
            "temperature": (that.randomNum(200,400)/10).toFixed(2),
            "co2": 10,//二氧化碳
            "nh3": (that.randomNum(1000,9999)/100).toFixed(2),
            "H2S": (that.randomNum(1000,9999)/100).toFixed(2),
            "pm2_5": (that.randomNum(1000,9999)/100).toFixed(2),
            "pm10": 32,//可吸入颗粒物
            "dayTraffic": that.randomNum(10,100),
            "totalTraffic": that.randomNum(1000,99999),
            "nums": 4,//总位
            "list": [
              {
                "index": 1,
                "state": that.randomNum(1,10)%2
              },
              {
                "index": 2,
                "state": that.randomNum(1,10)%2
              },
              {
                "index": 3,
                "state": that.randomNum(1,10)%2
              }
            ]
          }
        };
        return JSON.stringify(obj);
      };
      },
    created() {
      // this.Weather();
      this.GetAddress();
    },
    beforeMount() {
    },
    mounted() {
      this.GetDate();
      // this.Refresh();
      this.ToUpdate();
      this.setDateTime = setInterval(this.Refresh, 1000);
    },
    beforeUpdate() {
    },
    updated() {
    },
    beforeDestroy() {
    },
    destroyed() {
      clearInterval(this.setDateTime);
      clearTimeout(this.timeout);
    },
    methods: {
      //获取周，日期和时间
      GetDate() {
        let weekArray = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
        let myDate = new Date();
        let getYear = myDate.getFullYear();
        let getMonth = myDate.getMonth() + 1;
        getMonth = getMonth < 10 ? "0" + getMonth : getMonth;
        let getDate = myDate.getDate();
        getDate = getDate < 10 ? "0" + getDate : getDate;
        let getHours = myDate.getHours();
        getHours = getHours < 10 ? '0' + getHours : getHours;
        let getMinutes = myDate.getMinutes();
        getMinutes = getMinutes < 10 ? '0' + getMinutes : getMinutes;
        let getSeconds = myDate.getSeconds();
        getSeconds = getSeconds < 10 ? '0' + getSeconds : getSeconds;
        this.weeks = weekArray[myDate.getDay()];
        this.dateTime = getYear + "-" + getMonth + "-" + getDate + " " + getHours + ":" + getMinutes + ":" + getSeconds;
      },
      //获取定位位置
      GetAddress() {
        let that = this;
        let geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(function (res) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            // console.log(res.address.city);
            that.weatherName = res.address.city;
            if (that.weatherName.lastIndexOf('市') !== -1) {
              that.weatherName = that.weatherName.substring(0, that.weatherName.lastIndexOf('市'));
            }
            that.Weather(that.weatherName);
          } else {
            console.log("定位失败：" + this.getStatus());
          }
        });
      },
      //获取天气
      Weather(paramName = '北京') {
        let that = this;
        this.$axios.get("http://tp.wucaishijie.xyz/api/juhe/index?city=" + paramName).then(function (res) {
          // console.log(res);
          if (!JSON.parse(res.data).error_code) {
            that.wid = JSON.parse(res.data).result.realtime.wid;
          } else {
            that.wid = '00';
            console.log("获取天气失败");
          }
        }).catch(function (err) {
          console.log("获取天气出错");
          console.log(err);
        });
      },
      /*刷新*/
      Refresh() {
        this.GetDate();
        this.toUpdData++;
        if (this.toUpdData>5){
          this.toUpdData=0;
          this.ToUpdate();
        }
      },
      /*生成从minNum到maxNum的随机数*/
      randomNum(minNum, maxNum) {
        switch (arguments.length) {
          case 1:
            return parseInt(Math.random() * minNum + 1, 10);
            break;
          case 2:
            return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
            break;
          default:
            return 0;
            break;
        }
      },
      /*计算剩余侧位*/
      GetSurplus(paramList=[],paramStr=0,paramValue=1){
        let result=0;
        for (let i=0;i<paramList.length;i++){
          if (paramList[i][paramStr]===paramValue){
            result++;
          }
        }
        return result;
      },
      /*计算总人流量*/
      GetPeopleFlow(paramArray=[],paramStr="totalTraffic"){
        let peopleFlowSum=0;
        for (let i=0;i<paramArray.length;i++){
          for (let key in paramArray[i]){
            if (key===paramStr){//总人数
              peopleFlowSum=peopleFlowSum+paramArray[i][key];
            }
          }
        }
        this.peopleFlow.peopleFlowSum=peopleFlowSum;
      },
      /*构造环境检测数据*/
      GetTesting(paramArray=[]){//男、女、三
        this.testing.male_H2S=paramArray[0].H2S;
        this.testing.male_pm2_5=paramArray[0].pm2_5;
        this.testing.male_nh3=paramArray[0].nh3;
        this.testing.female_H2S=paramArray[1].H2S;
        this.testing.female_pm2_5=paramArray[1].pm2_5;
        this.testing.female_nh3=paramArray[1].nh3;
        this.testing.third_H2S=paramArray[2].H2S;
        this.testing.third_pm2_5=paramArray[2].pm2_5;
        this.testing.third_nh3=paramArray[2].nh3;
      },
      /*更新数据*/
      ToUpdate(){
        // console.log("更新");
        let toiletInfo=JSON.parse(window.external.getDevInfo());
        this.male=toiletInfo.mensInfo;//赋值男厕信息.
        this.male['surplus']=toiletInfo.mensInfo.nums-this.GetSurplus(toiletInfo.mensInfo.list,'state');//计算剩余侧位
        this.peopleFlow.peopleFlowMale=toiletInfo.mensInfo.dayTraffic;//人流量
        this.female=toiletInfo.womensInfo;//赋值女厕信息
        this.female['surplus']=toiletInfo.womensInfo.nums-this.GetSurplus(toiletInfo.womensInfo.list,'state');//计算剩余侧位
        this.peopleFlow.peopleFlowFemale=toiletInfo.womensInfo.dayTraffic;//人流量
        this.third=toiletInfo.thirdsInfo;//赋值第三方厕信息
        this.third['surplus']=toiletInfo.thirdsInfo.nums-this.GetSurplus(toiletInfo.thirdsInfo.list,'state');//计算剩余侧位
        this.peopleFlow.peopleFlowThird=toiletInfo.thirdsInfo.dayTraffic;//人流量
        this.GetPeopleFlow([this.male,this.female,this.third]);//计算总人数
        this.GetTesting([this.male,this.female,this.third]);//构造环境监测数据格式，男，女，三
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index.vue